import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import StoreIcon from '@material-ui/icons/Store';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  openAssignmentModal,
  openAssignmentModalRestaurantsProducts,
} from '../../redux/actions/utilsActions';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';

export default function LowerToolBar(props: any) {
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();
  const dispatch: any = useDispatch();
  const disableAssignmentButton = useSelector(
    (state: RootStateOrAny) => state.UtilsReducers.disableAssignmentButton,
  );
  const { thisUser } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );

  const openAssignment = () => {
    if (assignmentFunction === 1) {
      dispatch(openAssignmentModal());
    } else if (assignmentFunction === 2) {
      dispatch(openAssignmentModalRestaurantsProducts());
    }
  };

  const [assignmentFunction, setAssignmentFunction] = useState(1);

  useEffect(() => {
    if (location.pathname.match(/^\/restaurants\/\d+\/products$/)) {
      setAssignmentFunction(2);
    } else {
      setAssignmentFunction(1);
    }
  }, [location]);

  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <Toolbar className={classes.lowerToolBar}>
        {location.pathname !== '/' && (
          <IconButton
            onClick={() => history.goBack()}
            aria-label="goback"
            size="small"
          >
            <ArrowBackIosIcon fontSize="inherit" />
          </IconButton>
        )}
        <div className={classes.title}>
          {
            //Pushes it to the right and it's open for further children impls like Typography
          }
        </div>
        {(thisUser.hasAssignEquipment || thisUser.hasAssignMenuItems) && (
          <Button
            variant="contained"
            color="primary"
            size="small"
            className={classes.button}
            startIcon={<StoreIcon />}
            onClick={openAssignment}
            disabled={disableAssignmentButton}
          >
            {t('home.assignment')}
          </Button>
        )}
      </Toolbar>
    </div>
  );
}
